import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { reduxForm } from 'redux-form';

import moment from 'moment';
import { eduNameAsyncValidate } from 'libs/validation';
import { Icon, Message, Image } from 'semantic-ui-react';

import {
  ModalTemplate,
  Button,
  ReduxFormMaterialTextField,
  ReduxFormDatePicker,
  ReduxFormHiddenRecord,
  ReduxFormSemanticDropdown,
  EduLicenseMessage,
  ReduxFormSemanticCheckBox,
  Loading
} from 'components';

import * as common from 'libs/commonFunc';

import styles from '../../../style/modal.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ModalExamAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      validationInfo: null,
      startDate: null,
      endDate: null,
      targetSelectCount: '',
      attachSelectCount: '',
      isNext: false
    };

    this.handleDatePickerOnChangeStart = this.handleDatePickerOnChangeStart.bind(this);
  }

  componentDidMount() {
    this.props.getEduInfo();
  }

  componentWillReceiveProps(nextProps) {
    const { formStore } = nextProps;
    const { licenseResult } = this.props;

    if (this.state.reactivateValidate === '') {
      // redux-form reset 후 change 이벤트 발생 전까지는 validate 동작이 안되는 것에 대한 임시 보완책
      this.setState({ reactivateValidate: 'colap' });
    } else if (!!licenseResult && licenseResult.error === 'noReserve') {
      if (formStore && formStore.values && formStore.values.startEpoch && formStore.values.endEpoch) {
        if (
          formStore.values.startEpoch !== this.props.formStore.values.startEpoch ||
          formStore.values.endEpoch !== this.props.formStore.values.endEpoch
        ) {
          this.props.initEduLicense();
        }
      }
    } else if (formStore && formStore.values && formStore.values.tagNoArray) {
      if (formStore.values.tagNoArray !== this.props.formStore.values.tagNoArray) {
        this.props.initEduLicense();
      }
    } else {
      //
    }
  }

  handleDatePickerOnChangeStart = (e, date) => {
    if (!!!date) {
      return false;
    }

    date
      .hour(0)
      .minute(0)
      .second(0);

    const dateObj = { startDate: date.unix() };

    if (!this.state.endDate) {
      dateObj.endDate = moment.unix(dateObj.startDate + 86400 * 1 - 1);
    }

    dateObj.startDate = moment.unix(dateObj.startDate);

    if (
      this.state.startDate &&
      this.state.endDate &&
      this.state.startDate.unix() + 86400 * 1 - 1 > this.state.endDate.unix()
    ) {
      // 시작 날짜를 종료 날짜 이후로 선택한 경우
      // 종료 날짜를 초기화 해준다.
      dateObj.endDate = null;
    }

    this.setState(dateObj);
  };

  handleDatePickerOnChangeEnd = (e, date) => {
    if (!!!date) {
      return false;
    }

    date
      .hour(23)
      .minute(59)
      .second(59);

    this.setState({
      endDate: date
    });
  };

  // 동영상별 퀴즈 리스트
  setQuizOption = fileNo => {
    const { eduVideoQuizInfo } = this.props;
    const eduQuizOption = [];
    eduVideoQuizInfo.map(value => {
      if (fileNo === value.fileNo) {
        value.quizInfo && value.quizInfo.map(quiz => {
          eduQuizOption.push({
            key: quiz.quizNo,
            value: quiz.quizNo,
            text: quiz.quizContent
          });
        });
      }
    });
    return eduQuizOption;
  };

  handleNext = (value) => {
    this.setState({
      isNext: value
    })
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      visible,
      formStore,
      startDate,
      endDate,
      eduExamOrdering,
      eduExamByExamNo,
      eduAttachOrdering,
      eduAttachByAttachNo,
      eduTagByTagNo,
      tagData,
      // 교육 실시
      onPostEdu,
      // 로딩 & 클릭
      isClicked,
      isLoading,
      // 에러 & 에러 결과
      isError,
      licenseResult,
      onGetVideoQuiz,
      eduVideoQuizInfo
    } = this.props;

    const { onToggleModal, handleChangeExam } = this.props;
    const { isNext } = this.state;

    const dateFormat = localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD';

    // 교육 기간
    let reserveEdu = '';
    let periodExam = '';

    if (formStore && formStore.values && formStore.values.startEpoch) {
      const startMoment = moment(formStore.values.startEpoch);
      if (moment() < startMoment) {
        reserveEdu = defineMessages(formatMessage({ id: 'EduAdd_2', defaultMessage: '교육을 예약함' }));
      }

      if (formStore.values.endEpoch && formStore.values.endEpoch > formStore.values.startEpoch + 86400 * 1) {
        const endMoment = moment(formStore.values.endEpoch);
        periodExam =
          defineMessages(formatMessage({ id: 'EduAdd_3', defaultMessage: '교육 기간' })) +
          ': ' +
          moment.duration(endMoment.diff(startMoment)).humanize();
      }
    }

    // 전체 훈련 리스트
    const eduExamOption = [];

    eduExamOrdering.map(examNo => {
      const examItem = eduExamByExamNo.get(String(examNo));

      eduExamOption.push({
        key: examItem.get('examNo'),
        value: examItem.get('examNo'),
        text: examItem.get('examName')
      });
    });

    // 전체 컨텐츠 리스트
    const eduAttachOption = [];

    eduAttachOrdering.map(eduAttachNo => {
      const attachItem = eduAttachByAttachNo.get(String(eduAttachNo));

      eduAttachOption.push({
        key: attachItem.get('eduAttachNo'),
        value: attachItem.get('eduAttachNo'),
        text: attachItem.get('attachName')
      });
    });


    // 전체 태그 리스트
    let tagDataByName = {};
    let tagTargetCount = 0;
    if (tagData && typeof eduTagByTagNo === 'object') {
      for (const no in tagData) {
        if (tagData.hasOwnProperty(no)) {
          tagTargetCount += tagData[no].targetCount || 0;

          tagDataByName[tagData[no].tagName] = {
            key: no,
            value: parseInt(no, 10),
            label: { className: 'tag-' + tagData[no].color, empty: true, circular: true },
            data: {
              color: 'tag-label-' + tagData[no].color
            },
            text:
              tagData[no].tagName +
              ' - ' +
              tagData[no].targetCount +
              defineMessages(formatMessage({ id: 'StartExamWizardContent_13', defaultMessage: '명' })),
            content: (
              <div className="item-info">
                <div className="list-name">{tagData[no].tagName}</div>
                <div className="list-target-count">
                  {tagData[no].targetCount +
                    ' ' +
                    defineMessages(formatMessage({ id: 'StartExamWizardContent_13', defaultMessage: '명' }))}
                </div>
              </div>
            ),
            className: 'list-item',
            disabled: tagData[no].targetCount ? false : true
          };
        }
      }
    }

    // 정렬 처리 - 대상자가 있는 태그순, ㄱㄴㄷ순
    tagDataByName = common.sortObjectByKey(tagDataByName);

    const enabledtagOptions = [];
    const disabledTagOptions = [];
    for (const name in tagDataByName) {
      if (tagDataByName.hasOwnProperty(name)) {
        // 대상자가 있는 태그 먼저 표시
        if (!tagDataByName[name].disabled) {
          disabledTagOptions.push(tagDataByName[name]);
        } else {
          enabledtagOptions.push(tagDataByName[name]);
        }
      }
    }

    const tagOptions = disabledTagOptions.concat(enabledtagOptions);

    let renderTagList = null;
    // if (!loading) {
    if (Array.isArray(tagOptions) && tagOptions.length > 0) {
      let tagTargetPlacholder = defineMessages(
        formatMessage({ id: 'Edu_7', defaultMessage: '교육 실시할 태그를 선택하세요' })
      );
      if (tagTargetCount === 0) {
        tagTargetPlacholder = defineMessages(
          formatMessage({
            id: 'StartExamWizardContent_14',
            defaultMessage: '태그에 할당된 대상자가 없습니다'
          })
        );
      }

      renderTagList = (
        <ReduxFormSemanticDropdown
          placeholder={tagTargetPlacholder}
          required
          name="tagNoArray"
          className={cx('list-target', 'eduExam-dropdown')}
          fluid
          multiple
          search
          selection
          selectOnBlur={false}
          // disabled={formStore && formStore.values && formStore.values.isAllTarget ? true : false}
          options={tagOptions}
          // loading={loadingTargetTag}
          error={
            formStore &&
            formStore.fields &&
            formStore.fields['tagNoArray'] &&
            formStore.fields['tagNoArray'].touched &&
            (formStore.fields['tagNoArray'].touched &&
              (!!!formStore.values.tagNoArray || formStore.values.tagNoArray.length === 0))
          }
          errorMessage={formStore && formStore.syncErrors && formStore.syncErrors.eduTargetSelected}
          checkType={101}
          renderLabel={(label, index) => ({
            className: label.data.color,
            content: label.text
          })}
        />
      );
    } else {
      renderTagList = (
        <Message warning size="small">
          <Message.Header>
            <Icon name="exclamation circle" />
            {defineMessages(
              formatMessage({ id: 'StartExamWizardContent_16', defaultMessage: '대상자 태그가 없습니다.' })
            )}
          </Message.Header>
          <p>
            {defineMessages(
              formatMessage({
                id: 'StartExamWizardContent_17',
                defaultMessage:
                  '대상자를 추가하고 태그를 부여하면 태그를 이용하여 여러 대상자를 한번에 선택할 수 있습니다.'
              })
            )}
          </p>
        </Message>
      );
    }
    // }

    const eduAddComponent = (
      <div className={cx('modal-content', 'edu-edit-modal', 'add')}>
        <div className={cx('modalEduAdd-wrapper', 'step1', { active: !isNext })}>
          <div className={cx('wrapper-inner')}>
            <span className={cx('materialTextField-title')}>
              {defineMessages(formatMessage({ id: 'Edu_1', defaultMessage: '교육명' }))} *
            </span>
            <ReduxFormMaterialTextField
              className={cx('materialTextfield', 'input-area')}
              name="eduName"
              autoComplete="off"
              checkType={101}
              required
              validate={['required', 'examName']}
            />
          </div>
          <div className={cx('date-area')}>
            <div className={cx('date-input')}>
              <span className={cx('materialTextField-title')}>
                {defineMessages(formatMessage({ id: 'ModalExamEdit_5', defaultMessage: '시작일자' }))} *
              </span>
              <ReduxFormDatePicker
                defaultValue={moment()}
                helperText={reserveEdu}
                helperTextClassName="end-date-detail"
                className={cx('date-input')}
                name="startEpoch"
                locale={localStorage.getItem('language')}
                todayButton="Today"
                shouldCloseOnSelect //={false}
                selectsStart
                showYearDropdown
                dropdownMode="select"
                showMonthDropdown
                dateFormat={dateFormat}
                startDate={this.state.startDate}
                minDate={moment()}
                maxDate={moment('2037-11-30')}
                endDate={this.state.endDate}
                onChange={this.handleDatePickerOnChangeStart}
                checkType={100}
                validate={['dateRequired', 'reduxFormDatePicker']}
                error={formStore && formStore.values && formStore.values.startEpoch && !!!formStore.values.startEpoch}
              // noerror
              />
            </div>
            <div className={cx('date-input')}>
              <span className={cx('materialTextField-title')}>
                {defineMessages(formatMessage({ id: 'ModalExamEdit_6', defaultMessage: '종료일자' }))} *
              </span>
              <ReduxFormDatePicker
                helperText={periodExam}
                helperTextClassName="end-date-detail"
                defaultValue={moment().add(1, 'd')}
                className={cx('date-input')}
                name="endEpoch"
                locale={localStorage.getItem('language')}
                todayButton="Today"
                shouldCloseOnSelect //={false}
                selectsEnd
                showYearDropdown
                dropdownMode="select"
                showMonthDropdown
                dateFormat={dateFormat}
                startDate={moment(this.state.startDate).add(1, 'd')}
                minDate={moment(this.state.startDate).add(1, 'd')}
                maxDate={moment('2037-12-31')}
                endDate={moment(this.state.endDate)}
                onChange={this.handleDatePickerOnChangeEnd}
                checkType={101}
                validate={['dateRequired', 'reduxFormDatePicker']}
                error={
                  formStore &&
                  formStore.fields &&
                  formStore.fields['endEpoch'] &&
                  (formStore.fields['endEpoch'].visited &&
                    !!!formStore.fields['endEpoch'].active &&
                    !!!formStore.values.endEpoch)
                }
              />
            </div>
          </div>
          <div className={cx('wrapper-inner')}>
            <ReduxFormHiddenRecord
              name="eduTargetSelected"
              validate={['eduTargetRequried']}
              valuePass={
                formStore && formStore.values && formStore.values.tagNoArray && formStore.values.tagNoArray.length > 0
              }
            // valuePass={contentSelectCount || (formStore && formStore.values && formStore.values.isAllTarget)}
            />
            <span className={cx('materialTextField-title')}>
              {defineMessages(formatMessage({ id: 'Edu_6', defaultMessage: '대상자 태그' }))} *
            </span>
            <div className={cx('list-dropdown', 'drop-area')}>{!!renderTagList && renderTagList}</div>
          </div>
          <div className={cx('wrapper-inner')}>
            <ReduxFormHiddenRecord
              name="eduAttachNoSelected"
              validate={['eduAttachRequried']}
              valuePass={formStore && formStore.values && formStore.values.eduAttachNo}
            />
            <span className={cx('materialTextField-title')}>
              {defineMessages(formatMessage({ id: 'Edu_8', defaultMessage: '교육 컨텐츠' }))} *
            </span>
            <ReduxFormSemanticDropdown
              className={cx('eduExam-dropdown', 'drop-area')}
              placeholder={defineMessages(formatMessage({ id: 'Edu_9', defaultMessage: '교육 컨텐츠를 선택하세요' }))}
              // required
              name="eduAttachNo"
              fluid
              search
              selection
              autoFocus
              options={eduAttachOption}
              // onChange={handleChangeExam}
              error={
                formStore &&
                formStore.fields &&
                formStore.fields['eduAttachNo'] &&
                formStore.fields['eduAttachNo'].touched &&
                (formStore.fields['eduAttachNo'].touched &&
                  (!!!formStore.values.eduAttachNo || formStore.values.eduAttachNo.length > 0))
              }
              errorMessage={formStore && formStore.syncErrors && formStore.syncErrors.eduAttachNoSelected}
            />
          </div>
          <div className={cx('wrapper-inner')}>
            <ReduxFormSemanticCheckBox
              name="insertQuiz"
              className={cx('input-check')}
              label={defineMessages(formatMessage({ id: 'Edu_58', defaultMessage: '컨텐츠에 퀴즈 삽입' }))}
            />
          </div>
          <div className={cx('wrapper-inner')}>
            <span className={cx('materialTextField-title')}>
              {defineMessages(formatMessage({ id: 'Edu_10', defaultMessage: '연결훈련' }))}
            </span>
            <ReduxFormSemanticDropdown
              className={cx('eduExam-dropdown')}
              placeholder={defineMessages(
                formatMessage({ id: 'Edu_11', defaultMessage: '교육과 연결시킬 훈련을 선택하세요' })
              )}
              name="examNoArray"
              multiple
              fluid
              search
              selection
              autoFocus
              options={eduExamOption}
              onChange={handleChangeExam}
            // defaultValue={examNoArray.get(String(selectEditEduNo))}
            />
          </div>
        </div>
        <div className={cx('modalEduAdd-wrapper', 'step2', { active: isNext })}>
          {eduVideoQuizInfo && eduVideoQuizInfo.map((value, index) => {
            return (
              <div key={index} className={'quiz-group'}>
                <div className={cx('quiz-title')}>
                  {`${index + 1}. ${value.fileName}`}
                </div>
                <ReduxFormSemanticDropdown
                  className={cx('eduExam-dropdown', 'drop-area')}
                  placeholder={defineMessages(formatMessage({ id: 'ModalEdu_13', defaultMessage: '퀴즈를 선택하세요' }))}
                  name={'quizNoArray' + value.fileNo}
                  multiple
                  fluid
                  search
                  selection
                  autoFocus
                  disabled={this.setQuizOption(value.fileNo).length < 1}
                  options={this.setQuizOption(value.fileNo)}
                />
              </div>
            );
          })}
        </div>
      </div>
    );

    const eduHeader = (
      <div className={cx('edu-header')}>
        <div className={cx('edu-title')}>{defineMessages(formatMessage({ id: 'EduAdd_1', defaultMessage: '교육 실시' }))}</div>
        <div className={cx('edu-explain')}>
          {isNext
            ? defineMessages(formatMessage({ id: 'Edu_63', defaultMessage: '교육 컨텐츠에 삽입할 퀴즈를 선택합니다.' }))
            : <div>
              {defineMessages(formatMessage({ id: 'Edu_62', defaultMessage: '교육명 및 교육기간을 입력하고, 대상자 태그 및 교육 컨텐츠를 선택합니다.' }))}
            </div>
          }
        </div>
      </div>
    );

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        closeIcon={<Image src="/img/common/close_black.png" className={cx('bt-startEdu-close icon')} />}
        className={cx('modal-edu-area', 'common-content')}
        visible={visible}
        header={eduHeader}
        onToggleModal={onToggleModal}
        buttons={
          <div className={cx('inline-block', 'button-area')}>
            {isNext && <Button
              className={'prev-button'}
              onClick={() => {
                this.handleNext(false);
              }}>
              <Image src={'/img/examStart/btn_prev.png'} />
              <span>{defineMessages(formatMessage({ id: 'ModalEdu_14', defaultMessage: '이 전' }))}</span>
            </Button>}
            {!isNext && formStore && formStore.values && formStore.values.insertQuiz === 1 &&
              <Button
                className={cx('brand-button')}
                // loading={loading}
                disabled={(!!formStore && !!formStore.values && !!formStore.syncErrors) || !!isError}
                onClick={e => {
                  e.stopPropagation();
                  // 필수 입력 값 모두 입력 시 퀴즈 선택 화면으로 변경
                  if (!formStore.syncErrors) {
                    this.handleNext(true);
                    onGetVideoQuiz();
                  } else {
                    // validation 표시해주기 위함(등록 이벤트는 실제로 수행되지 않음)
                    onPostEdu();
                  }
                }}>
                <span>{defineMessages(formatMessage({ id: 'ModalEdu_4', defaultMessage: '다 음' }))}</span>
                <Image src={'/img/examStart/btn_next.png'} />
              </Button>
            }
            {((formStore && formStore.values && formStore.values.insertQuiz !== 1) || isNext) &&
              <Button
                className={cx('brand-button')}
                // loading={loading}
                disabled={(!!formStore && !!formStore.values && !!formStore.syncErrors) || !!isError}
                onClick={e => {
                  e.stopPropagation();
                  if (!formStore.syncErrors) {
                    onPostEdu();
                  }
                }}>
                <span>{defineMessages(formatMessage({ id: 'StartExamWizardButton_3', defaultMessage: '실 행' }))}</span>
              </Button>}
          </div>
        }>
        {isLoading &&
          <Loading
            size="small"
            content={"Loading..."}
          />}
        {eduAddComponent}
        {!!isError ? <EduLicenseMessage licenseResult={licenseResult} /> : ''}
      </ModalTemplate>
    );
  }
}

ModalExamAdd.propTypes = {
  onToggleModal: PropTypes.func
};


export default (
  reduxForm({
    form: 'formEduPost',
    enableReinitialize: true,
    asyncValidate: eduNameAsyncValidate,
    asyncBlurFields: ['eduName'],
    destroyOnUnmount: false,
    touchOnChange: true // validation 안내를 적절한 시점에 보이기 위해 반드시 필요함,
  })(injectIntl(ModalExamAdd))
);



// WEBPACK FOOTER //
// ./src/script/components/modal/ModalEduAdd.js